/**
 * Japanese (Japan) Pokémon names — official localized names.
 */
const jaJP: Record<string, string> = {
  venusaur: "フシギバナ",
  charizard: "リザードン",
  "mega-charizard-x": "メガリザードンX",
  "mega-charizard-y": "メガリザードンY",
  blastoise: "カメックス",
  pikachu: "ピカチュウ",
  "alolan-raichu": "アローラのライチュウ",
  clefable: "ピクシー",
  "alolan-ninetales": "アローラのキュウコン",
  wigglytuff: "プクリン",
  meowth: "ニャース",
  psyduck: "コダック",
  machamp: "カイリキー",
  "galarian-rapidash": "ガラルのギャロップ",
  slowbro: "ヤドラン",
  dodrio: "ドードリオ",
  gengar: "ゲンガー",
  blissey: "ハピナス",
  "mr-mime": "バリヤード",
  scizor: "ハッサム",
  gyarados: "ギャラドス",
  "mega-gyarados": "メガギャラドス",
  lapras: "ラプラス",
  vaporeon: "シャワーズ",
  snorlax: "カビゴン",
  zapdos: "サンダー",
  moltres: "ファイヤー",
  dragonite: "カイリュー",
  mewtwox: "メガミュウツーX",
  mewtwoy: "メガミュウツーY",
  "mega-mewtwo-x": "メガミュウツーX",
  "mega-mewtwo-y": "メガミュウツーY",
  mew: "ミュウ",
  azumarill: "マリルリ",
  espeon: "エーフィ",
  umbreon: "ブラッキー",
  mamoswine: "マンムー",
  suicune: "スイクン",
  tyranitar: "バンギラス",
  "ho-oh": "ホウオウ",
  blaziken: "バシャーモ",
  gardevoir: "サーナイト",
  sableye: "ヤミラミ",
  absol: "アブソル",
  metagross: "メタグロス",
  latias: "ラティアス",
  latios: "ラティオス",
  empoleon: "エンペルト",
  garchomp: "ガブリアス",
  lucario: "ルカリオ",
  "mega-lucario": "メガルカリオ",
  leafeon: "リーフィア",
  glaceon: "グレイシア",
  darkrai: "ダークライ",
  crustle: "イワパレス",
  zoroark: "ゾロアーク",
  chandelure: "シャンデラ",
  delphox: "マフォクシー",
  greninja: "ゲッコウガ",
  talonflame: "ファイアロー",
  aegislash: "ギルガルド",
  sylveon: "ニンフィア",
  goodra: "ヌメルゴン",
  trevenant: "オーロット",
  hoopa: "フーパ",
  decidueye: "ジュナイパー",
  tsareena: "アマージョ",
  comfey: "キュワワー",
  mimikyu: "ミミッキュ",
  dhelmise: "ダダリン",
  buzzwole: "マッシブーン",
  zeraora: "ゼラオラ",
  cinderace: "エースバーン",
  inteleon: "インテレオン",
  greedent: "ヨクバリス",
  eldegoss: "ワタシラガ",
  cramorant: "ウッウ",
  sirfetchd: "ネギガナイト",
  alcremie: "マホイップ",
  falinks: "タイレーツ",
  duraludon: "ジュラルドン",
  dragapult: "ドラパルト",
  zacian: "ザシアン",
  urshifu: "ウーラオス",
  meowscarada: "マスカーニャ",
  pawmot: "パーモット",
  armarouge: "グレンアルマ",
  ceruledge: "ソウブレイズ",
  tinkaton: "デカヌチャン",
  typhlosion: "バクフーン",
  miraidon: "ミライドン",
  // Maps — names and descriptions
  "map-groudon": "テイアの天空遺跡",
  "map-groudon.description": "グラードンが登場する5v5マップ。",
  "map-kyogre": "テイアの天空遺跡",
  "map-kyogre.description": "カイオーガが登場する5v5マップ。",
  "map-rayquaza": "テイアの天空遺跡",
  "map-rayquaza.description": "レックウザが登場する5v5マップ。",
  // Neutrals (wild Pokémon / items)
  accelgor: "アッケラー",
  altaria: "チルタリス",
  baltoy: "ヤドン",
  bunnelby: "ホルビー",
  escavalier: "シュバルゴ",
  groudon: "グラードン",
  indeedee: "イエッサン",
  kyogre: "カイオーガ",
  natu: "ネイティ",
  rayquaza: "レックウザ",
  regidrago: "レジドラゴ",
  regice: "レジアイス",
  regieleki: "レジエレキ",
  regirock: "レジロック",
  registeel: "レジスチル",
  salac: "サラクのみ",
  sitrus: "オボンのみ",
  xatu: "ネイティオ",
  // Spawn info (HTML)
  "spawn.info.groudon.boss":
    "<p>撃破すると、生存している味方全員が<strong>バフ</strong>と<strong>15アエオスポイント</strong>を獲得。<br>このバフは<strong>所持者がノックアウトされるまで永続</strong>。ノックアウトされるとバフは<strong>与えた側に移る</strong>。<br><strong>ゴール速度上昇</strong>・<strong>大ダメージ上昇</strong>・<strong>小シールド</strong>。<br>2:00に出現。</p>",
  "spawn.info.bunnelby.initial":
    "<p><strong>試合開始時に出現</strong>し、<strong>撃破後は再出現しない</strong>。</p><p>2ポイント獲得。</p>",
  "spawn.info.bunnelby.lane_940":
    "<p><strong>9:40</strong>から出現。<br>撃破で<strong>2ポイント</strong>獲得、<strong>60秒</strong>後に再出現。<br>レーンの<strong>最初のタワー</strong>が破壊されると<strong>消滅</strong>。</p>",
  "spawn.info.bunnelby.lane_920":
    "<p><strong>9:20</strong>から出現。<br>撃破で<strong>2ポイント</strong>獲得、<strong>60秒</strong>後に再出現。<br>レーンの<strong>最初のタワー</strong>が破壊されると<strong>消滅</strong>。</p>",
  "spawn.info.bunnelby.lane_915":
    "<p><strong>9:15</strong>から出現。<br>撃破で<strong>2ポイント</strong>獲得、<strong>60秒</strong>後に再出現。<br>レーンの<strong>最初のタワー</strong>が破壊されると<strong>消滅</strong>。</p>",
  "spawn.info.accelgor":
    "<p><strong>9:45</strong>から出現。撃破で<strong>4/7ポイント</strong>と<strong>バフ</strong>。<strong>60秒</strong>後に再出現。<br>バフは<strong>70秒</strong>間、<strong>わざのクールダウン10%短縮</strong>。</p>",
  "spawn.info.escavalier":
    "<p><strong>9:45</strong>から出現。撃破で<strong>4/7ポイント</strong>と<strong>バフ</strong>。<strong>60秒</strong>後に再出現。<br>バフは<strong>70秒</strong>間、<strong>基本攻撃ダメージ上昇・相手の移動速度短時間低下</strong>。</p>",
  "spawn.info.baltoy.generic":
    "<p><strong>9:45</strong>から出現。撃破で<strong>2ポイント</strong>。<strong>60秒</strong>後に再出現。</p>",
  "spawn.info.baltoy.lane_940":
    "<p><strong>9:40</strong>から出現。撃破で<strong>2ポイント</strong>。<strong>60秒</strong>後に再出現。レーンの<strong>最初のタワー</strong>破壊で<strong>消滅</strong>。</p>",
  "spawn.info.baltoy.lane_920":
    "<p><strong>9:40</strong>から出現。撃破で<strong>2ポイント</strong>。<strong>60秒</strong>後に再出現。レーンの<strong>最初のタワー</strong>破壊で<strong>消滅</strong>。</p>",
  "spawn.info.baltoy.lane_910":
    "<p><strong>9:10</strong>から出現。撃破で<strong>2ポイント</strong>。<strong>60秒</strong>後に再出現。レーンの<strong>最初のタワー</strong>破壊で<strong>消滅</strong>。</p>",
  "spawn.info.baltoy.lane_910_only":
    "<p><strong>9:10</strong>から出現。撃破で<strong>2ポイント</strong>。<strong>60秒</strong>後に再出現。</p>",
  "spawn.info.baltoy.lane_840":
    "<p><strong>8:40</strong>から出現。撃破で<strong>2ポイント</strong>。<strong>60秒</strong>後に再出現。</p>",
  "spawn.info.baltoy.tower":
    "<p>対応する<strong>最初のタワー</strong>破壊後に出現。撃破で<strong>2ポイント</strong>。<strong>60秒</strong>後に再出現。</p>",
  "spawn.info.regidrago":
    "<p><strong>8:00</strong>にマップ中央に出現。撃破から<strong>1:30</strong>後にチルタリスが出現。<br>撃破したチームは<strong>味方全員に経験値</strong>。とどめを刺したプレイヤーは<strong>得点速度バフ</strong>と<strong>20ポイント</strong>。</p>",
  "spawn.info.regieleki":
    "<p><strong>7:00</strong>にトップ/ボトムのいずれかのレーンに出現。撃破すると相手陣地へ。陣地に到達で<strong>20/16/12/8ポイント</strong>、陣地が健在なら<strong>20/15/10/5秒間ゴール即時</strong>。<br>とどめで<strong>20ポイント</strong>。撃破から<strong>2分</strong>で再出現。</p>",
  "spawn.info.regi.700":
    "<p><strong>7:00</strong>に出現。</p>",
  "spawn.info.xatu":
    "<p><strong>9:59</strong>に出現。撃破で<strong>大量経験値</strong>と<strong>2ポイント</strong>。<strong>再出現なし</strong>。</p>",
  "spawn.info.natu.900":
    "<p><strong>9:00</strong>に出現。</p>",
  "spawn.info.natu.920":
    "<p><strong>9:20</strong>に出現。</p>",
  "spawn.info.indeedee.lane":
    "<p><strong>9:30</strong>/<strong>9:35</strong>から出現。撃破で<strong>60秒</strong>後に再出現、<strong>5ポイント</strong>。レーンの<strong>最初のタワー</strong>破壊で<strong>消滅</strong>。</p>",
  "spawn.info.indeedee.tower":
    "<p>対応する<strong>最初のタワー</strong>破壊後に出現。撃破で<strong>60秒</strong>後に再出現、<strong>5ポイント</strong>。</p>",
  "spawn.info.salac":
    "<p>使用で<strong>3秒間</strong><strong>移動速度アップ</strong>。<strong>8:30</strong>から出現、使用後<strong>60秒</strong>で再出現。</p>",
  "spawn.info.salac.short":
    "<p>3秒間移動速度アップ。</p>",
  "spawn.info.altaria.after_regidrago":
    "<p>レジドラゴ撃破から<strong>1:30</strong>後に出現。</p>",
  "spawn.info.altaria.rayquaza":
    "<p><strong>8:00</strong>に出現、<strong>1:30</strong>ごとに再出現。<strong>2:30</strong>に消滅。</p>",
  "spawn.info.kyogre.boss":
    "<p>撃破すると生存味方全員が<strong>バフ</strong>と<strong>15アエオスポイント</strong>を獲得。相手の残存タワーは1:30間無効（シールド・回復不可）。<br>バフは<strong>所持者がノックアウトされるまで永続</strong>。ノックアウトで<strong>与えた側に移る</strong>。<br><strong>ゴール速度上昇</strong>・<strong>自己回復(毎秒5%)</strong>・<strong>小シールド</strong>。<br>2:00に出現。</p>",
  "spawn.info.rayquaza.boss":
    "<p>撃破で勝利チームに<strong>15アエオスポイント</strong>と<strong>シールド</strong>（得点速度上昇・ゴール妨害無効）。<br>2:00に出現。</p>",
  "spawn.info.regidrago.kyogre":
    "<p><strong>8:00</strong>にマップ中央に出現。</p>",
  "spawn.info.xatu.short":
    "<p><strong>9:59</strong>に出現。</p>",
  "spawn.info.indeedee.tower_break":
    "<p>タワー破壊で出現。</p>",
  "spawn.info.baltoy.tower_break":
    "<p>タワー破壊で出現。</p>",
  "spawn.info.bunnelby.lane":
    "<p><strong>9:40</strong>から出現。</p>",
  "spawn.info.bunnelby.lane_920_short":
    "<p><strong>9:20</strong>から出現。</p>",
  "spawn.info.bunnelby.lane_915_short":
    "<p><strong>9:15</strong>から出現。</p>",
  "spawn.info.baltoy.lane_940_short":
    "<p><strong>9:40</strong>から出現。</p>",
  "spawn.info.baltoy.945_short":
    "<p><strong>9:45</strong>から出現。</p>",
  "spawn.info.baltoy.lane_910_short":
    "<p><strong>9:10</strong>から出現。</p>",
  "spawn.info.baltoy.lane_840_short":
    "<p><strong>8:40</strong>から出現。</p>",
  "spawn.info.indeedee.lane_930":
    "<p><strong>9:30</strong>から出現。</p>",
  "spawn.info.indeedee.lane_935":
    "<p><strong>9:35</strong>から出現。</p>",
  "spawn.info.bunnelby.points":
    "<p>2ポイント獲得。</p>",
  "spawn.info.baltoy.tower_kyogre":
    "<p>対応する<strong>最初のタワー</strong>破壊後に出現。</p>",
  "spawn.info.indeedee.tower_short":
    "<p>対応する<strong>最初のタワー</strong>破壊後に出現。</p>",
  // @begin move-names-i18n
  "move.acid-spray": "アシッドボム",
  "move.acrobatics": "アクロバット",
  "move.aerial-ace": "つばめがえし",
  "move.agility": "こうそくいどう",
  "move.air-slash": "エアスラッシュ",
  "move.amnesia": "ドわすれ",
  "move.anchor-shot": "アンカーショット",
  "move.ancient-power": "げんしのちから",
  "move.aqua-jet": "アクアジェット",
  "move.aqua-ring": "アクアリング",
  "move.aqua-tail": "アクアテール",
  "move.armor-cannon": "アーマーキャノン",
  "move.assurance": "ダメおし",
  "move.astonish": "おどろかす",
  "move.aurora-veil": "オーロラベール",
  "move.avalanche": "ゆきなだれ",
  "move.baby-doll-eyes": "つぶらなひとみ",
  "move.barrier": "バリアー",
  "move.beat-up": "ふくろだたき",
  "move.belch": "ゲップ",
  "move.bite": "かみつく",
  "move.bitter-blade": "むねんのつるぎ",
  "move.blaze": "もうか",
  "move.blaze-kick": "ブレイズキック",
  "move.blizzard": "ふぶき",
  "move.block": "とおせんぼう",
  "move.bone-rush": "ボーンラッシュ",
  "move.bounce": "とびはねる",
  "move.branch-poke": "えだづき",
  "move.brave-bird": "ブレイブバード",
  "move.brutal-swing": "ぶんまわす",
  "move.bubble": "あわ",
  "move.bubble-beam": "バブルこうせん",
  "move.bulk-up": "ビルドアップ",
  "move.bulldoze": "じならし",
  "move.bullet-punch": "バレットパンチ",
  "move.bullet-seed": "タネマシンガン",
  "move.calm-mind": "めいそう",
  "move.charge-beam": "チャージビーム",
  "move.charm": "あまえる",
  "move.close-combat": "インファイト",
  "move.coaching": "コーチング",
  "move.confuse-ray": "あやしいひかり",
  "move.confusion": "ねんりき",
  "move.cotton-guard": "コットンガード",
  "move.cotton-spore": "わたほうし",
  "move.covet": "ほしがる",
  "move.cross-chop": "クロスチョップ",
  "move.curse": "のろい",
  "move.cut": "いあいぎり",
  "move.dark-pulse": "あくのはどう",
  "move.dark-void": "ダークホール",
  "move.dazzling-gleam": "マジカルシャイン",
  "move.decorate": "デコレーション",
  "move.defense-curl": "まるくなる",
  "move.detect": "みきり",
  "move.dig": "あなをほる",
  "move.disable": "かなしばり",
  "move.disarming-voice": "チャームボイス",
  "move.discharge": "ほうでん",
  "move.dive": "ダイビング",
  "move.double-hit": "ダブルアタック",
  "move.double-slap": "おうふくビンタ",
  "move.double-team": "かげぶんしん",
  "move.draco-meteor": "りゅうせいぐん",
  "move.dragon-breath": "りゅうのいぶき",
  "move.dragon-cheer": "ドラゴンエール",
  "move.dragon-claw": "ドラゴンクロー",
  "move.dragon-dance": "りゅうのまい",
  "move.dragon-pulse": "りゅうのはどう",
  "move.dragon-rush": "ドラゴンダイブ",
  "move.dragon-tail": "ドラゴンテール",
  "move.draining-kiss": "ドレインキッス",
  "move.dream-eater": "ゆめくい",
  "move.drill-peck": "ドリルくちばし",
  "move.dual-wingbeat": "ダブルウイング",
  "move.dynamic-punch": "ばくれつパンチ",
  "move.earthquake": "じしん",
  "move.egg-bomb": "タマゴばくだん",
  "move.electro-ball": "エレキボール",
  "move.electro-drift": "イナズマドライブ",
  "move.electroweb": "エレキネット",
  "move.ember": "ひのこ",
  "move.eruption": "ふんか",
  "move.explosive-heat-haze": "エクスプローシブヒートヘイズ",
  "move.extreme-speed": "しんそく",
  "move.fairy-wind": "ようせいのかぜ",
  "move.fake-out": "ねこだまし",
  "move.fake-tears": "うそなき",
  "move.feather-dance": "フェザーダンス",
  "move.feint": "フェイント",
  "move.feint-attack": "だましうち",
  "move.fell-stinger": "とどめばり",
  "move.fire-blast": "だいもんじ",
  "move.fire-punch": "ほのおのパンチ",
  "move.fire-spin": "ほのおのうず",
  "move.flail": "じたばた",
  "move.flame-burst": "はじけるほのお",
  "move.flame-charge": "ニトロチャージ",
  "move.flame-wheel": "かえんぐるま",
  "move.flamethrower": "かえんほうしゃ",
  "move.flare-blitz": "フレアドライブ",
  "move.flash-cannon": "ラスターカノン",
  "move.flip-turn": "クイックターン",
  "move.floral-healing": "フラワーヒール",
  "move.flower-trick": "トリックフラワー",
  "move.fly": "そらをとぶ",
  "move.focus-blast": "きあいだま",
  "move.follow-me": "このゆびとまれ",
  "move.foul-play": "イカサマ",
  "move.freeze-dry": "フリーズドライ",
  "move.fury-cutter": "れんぞくぎり",
  "move.fury-swipes": "みだれひっかき",
  "move.future-sight": "みらいよち",
  "move.giga-drain": "ギガドレイン",
  "move.gigaton-hammer": "デカハンマー",
  "move.grass-knot": "くさむすび",
  "move.grassy-glide": "グラススライダー",
  "move.gravity": "じゅうりょく",
  "move.growl": "なきごえ",
  "move.gyro-ball": "ジャイロボール",
  "move.headbutt": "ずつき",
  "move.heal-pulse": "いやしのはどう",
  "move.heat-wave": "ねっぷう",
  "move.heavy-slam": "ヘビーボンバー",
  "move.helping-hand": "てだすけ",
  "move.hex": "たたりめ",
  "move.high-horsepower": "１０まんばりき",
  "move.hone-claws": "つめとぎ",
  "move.horn-leech": "ウッドホーン",
  "move.hurricane": "ぼうふう",
  "move.hydro-cannon": "ハイドロカノン",
  "move.hydro-pump": "ハイドロポンプ",
  "move.hyper-beam": "はかいこうせん",
  "move.hyper-voice": "ハイパーボイス",
  "move.hyperspace-hole": "いじげんホール",
  "move.hypnosis": "さいみんじゅつ",
  "move.ice-beam": "れいとうビーム",
  "move.ice-fang": "こおりのキバ",
  "move.ice-hammer": "アイスハンマー",
  "move.ice-shard": "こおりのつぶて",
  "move.icicle-crash": "つららおとし",
  "move.icicle-spear": "つららばり",
  "move.icy-wind": "こごえるかぜ",
  "move.imprison": "ふういん",
  "move.incinerate": "やきつくす",
  "move.iron-defense": "てっぺき",
  "move.iron-head": "アイアンヘッド",
  "move.jump-kick": "とびげり",
  "move.karate-chop": "からてチョップ",
  "move.knock-off": "はたきおとす",
  "move.laser-focus": "とぎすます",
  "move.lava-plume": "ふんえん",
  "move.leaf-blade": "リーフブレード",
  "move.leaf-storm": "リーフストーム",
  "move.leaf-tornado": "グラスミキサー",
  "move.leafage": "このは",
  "move.leech-life": "きゅうけつ",
  "move.lick": "したでなめる",
  "move.light-screen": "ひかりのかべ",
  "move.liquidation": "アクアブレイク",
  "move.low-sweep": "ローキック",
  "move.lunge": "とびかかる",
  "move.luster-purge": "ラスターパージ",
  "move.mach-punch": "マッハパンチ",
  "move.magical-leaf": "マジカルリーフ",
  "move.magnet-rise": "でんじふゆう",
  "move.mean-look": "くろいまなざし",
  "move.mega-punch": "メガトンパンチ",
  "move.megahorn": "メガホーン",
  "move.metal-claw": "メタルクロー",
  "move.meteor-mash": "コメットパンチ",
  "move.mist-ball": "ミストボール",
  "move.moonblast": "ムーンフォース",
  "move.moonlight": "つきのひかり",
  "move.muddy-water": "だくりゅう",
  "move.mystical-fire": "マジカルフレイム",
  "move.nasty-plot": "わるだくみ",
  "move.night-shade": "ナイトヘッド",
  "move.night-slash": "つじぎり",
  "move.no-retreat": "はいすいのじん",
  "move.nuzzle": "ほっぺすりすり",
  "move.outrage": "げきりん",
  "move.overheat": "オーバーヒート",
  "move.pain-split": "いたみわけ",
  "move.parabolic-charge": "パラボラチャージ",
  "move.pay-day": "ネコにこばん",
  "move.payback": "しっぺがえし",
  "move.peck": "つつく",
  "move.perish-song": "ほろびのうた",
  "move.petal-dance": "はなびらのまい",
  "move.phantom-force": "ゴーストダイブ",
  "move.play-rough": "じゃれつく",
  "move.pollen-puff": "かふんだんご",
  "move.poltergeist": "ポルターガイスト",
  "move.pound": "はたく",
  "move.powder-snow": "こなゆき",
  "move.power-swap": "パワースワップ",
  "move.power-up-punch": "グロウパンチ",
  "move.power-whip": "パワーウィップ",
  "move.psybeam": "サイケこうせん",
  "move.psychic": "サイコキネシス",
  "move.psycho-cut": "サイコカッター",
  "move.psyshock": "サイコショック",
  "move.psystrike": "サイコブレイク",
  "move.pursuit": "おいうち",
  "move.pyro-ball": "かえんボール",
  "move.quick-attack": "でんこうせっか",
  "move.rapid-spin": "こうそくスピン",
  "move.razor-leaf": "はっぱカッター",
  "move.recover": "じこさいせい",
  "move.rest": "ねむる",
  "move.rock-polish": "ロックカット",
  "move.rock-slide": "いわなだれ",
  "move.rock-smash": "いわくだき",
  "move.rock-tomb": "がんせきふうじ",
  "move.rollout": "ころがる",
  "move.sacred-fire": "せいなるほのお",
  "move.sacred-sword": "せいなるつるぎ",
  "move.safeguard": "しんぴのまもり",
  "move.sand-attack": "すなかけ",
  "move.sand-tomb": "すなじごく",
  "move.scald": "ねっとう",
  "move.scratch": "ひっかく",
  "move.seed-bomb": "タネばくだん",
  "move.shadow-ball": "シャドーボール",
  "move.shadow-claw": "シャドークロー",
  "move.shadow-sneak": "かげうち",
  "move.shell-smash": "からをやぶる",
  "move.sing": "うたう",
  "move.skull-bash": "ロケットずつき",
  "move.sky-attack": "ゴッドバード",
  "move.slack-off": "なまける",
  "move.slash": "きりさく",
  "move.sludge-bomb": "ヘドロばくだん",
  "move.smack-down": "うちおとす",
  "move.smart-strike": "スマートホーン",
  "move.smokescreen": "えんまく",
  "move.snarl": "バークアウト",
  "move.snipe-shot": "ねらいうち",
  "move.soft-boiled": "タマゴうみ",
  "move.solar-beam": "ソーラービーム",
  "move.solar-blade": "ソーラーブレード",
  "move.spark": "スパーク",
  "move.spirit-shackle": "かげぬい",
  "move.splash": "はねる",
  "move.stealth-rock": "ステルスロック",
  "move.stomp": "ふみつけ",
  "move.stone-edge": "ストーンエッジ",
  "move.stored-power": "アシストパワー",
  "move.stuff-cheeks": "ほおばる",
  "move.submission": "じごくぐるま",
  "move.substitute": "みがわり",
  "move.sucker-punch": "ふいうち",
  "move.supercell-slam": "サンダーダイブ",
  "move.superpower": "ばかぢから",
  "move.surf": "なみのり",
  "move.surging-strikes": "すいりゅうれんだ",
  "move.sweet-kiss": "てんしのキッス",
  "move.sweet-scent": "あまいかおり",
  "move.swift": "スピードスター",
  "move.swords-dance": "つるぎのまい",
  "move.synthesis": "こうごうせい",
  "move.tackle": "たいあたり",
  "move.tail-whip": "しっぽをふる",
  "move.tailwind": "おいかぜ",
  "move.take-down": "とっしん",
  "move.tearful-look": "なみだめ",
  "move.telekinesis": "テレキネシス",
  "move.teleport": "テレポート",
  "move.thief": "どろぼう",
  "move.throat-chop": "じごくづき",
  "move.thunder": "かみなり",
  "move.thunder-punch": "かみなりパンチ",
  "move.thunder-shock": "でんきショック",
  "move.thunder-wave": "でんじは",
  "move.thunderbolt": "１０まんボルト",
  "move.trailblaze": "くさわけ",
  "move.tri-attack": "トライアタック",
  "move.trick": "トリック",
  "move.trick-room": "トリックルーム",
  "move.triple-axel": "トリプルアクセル",
  "move.trop-kick": "トロピカルキック",
  "move.twister": "たつまき",
  "move.vine-whip": "つるのムチ",
  "move.volt-switch": "ボルトチェンジ",
  "move.volt-tackle": "ボルテッカー",
  "move.water-gun": "みずでっぽう",
  "move.water-pulse": "みずのはどう",
  "move.water-shuriken": "みずしゅりけん",
  "move.water-spout": "しおふき",
  "move.waterfall": "たきのぼり",
  "move.whirlpool": "うずしお",
  "move.wicked-blow": "あんこくきょうだ",
  "move.wide-guard": "ワイドガード",
  "move.wild-charge": "ワイルドボルト",
  "move.will-o-wisp": "おにび",
  "move.wing-attack": "つばさでうつ",
  "move.wish": "ねがいごと",
  "move.wood-hammer": "ウッドハンマー",
  "move.x-scissor": "シザークロス",
  "move.yawn": "あくび",
  "move.zap-cannon": "でんじほう",
  "move.zen-headbutt": "しねんのずつき",
// @end move-names-i18n
  // Battle Items — standard Pokémon series items with known official JP names
  "battle-item.potion": "キズぐすり",
  "battle-item.full-heal": "なんでもなおし",
  "battle-item.eject-button": "ひきもどしボタン",
  // Held Items — standard Pokémon series items with known official JP names
  "held-item.leftovers": "たべのこし",
  "held-item.amulet-coin": "おまもりこばん",
  "held-item.rocky-helmet": "ゴツゴツメット",
  "held-item.razor-claw": "するどいツメ",
  "held-item.big-root": "おおきなねっこ",
  "held-item.rusted-sword": "さびたつるぎ",
  "held-item.mewtwonite-x": "ミュウツナイトX",
  "held-item.mewtwonite-y": "ミュウツナイトY",
  "held-item.lucarionite": "ルカリオナイト",
  "held-item.charizardite-x": "リザードナイトX",
  "held-item.charizardite-y": "リザードナイトY",
  "held-item.gyaradosite": "ギャラドスナイト",
};

export default jaJP;
